import { render, staticRenderFns } from "./ChildrenYN.vue?vue&type=template&id=3264d465"
import script from "./ChildrenYN.vue?vue&type=script&lang=js"
export * from "./ChildrenYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports